<span
  class="app-option__surface"
  appRipple
  [appRippleDisabled]="disabled"
  [appRippleCentered]="false"
>
  <span *ngIf="multiple" class="app-option__pseudo-checkbox" aria-hidden="true">
    <span class="app-option__pseudo-checkbox-mark"></span>
  </span>

  <span #text class="app-option__text"><ng-content></ng-content></span>

  <span
    *ngIf="!multiple && selected && !hideSingleSelectionIndicator"
    class="app-option__checkmark"
    aria-hidden="true"
  >
    <svg viewBox="0 0 24 24" focusable="false">
      <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
    </svg>
  </span>
</span>
